import { onUnmounted } from 'vue'
import type { IdleTimer, IdleTimerConfig } from '#src/modules/timer/interfaces/IdleTimer'

const INTERVAL_TIMEOUT = 1_000

export const useIdleTimer = (config: IdleTimerConfig) => {
  const calculateTimerDuration = (timer: IdleTimerConfig): number =>
    timer.duration + (timer.transitionDelay ?? 0)

  const idleTimer: IdleTimer = {
    currentIdleTime: calculateTimerDuration(config),
    idleTime: calculateTimerDuration(config),
    resetEvents: ['click', 'touchstart'],
    transitionDelay: 0,
    ...config
  }

  const cancelTimerSubscriptions = () => {
    idleTimer.resetEvents.forEach((event) => {
      document.removeEventListener(event, resetIdleTimer)
    })
  }

  const createIntervalInstance = () => {
    window.clearInterval(idleTimer.intervalInstance)
    idleTimer.currentIdleTime = idleTimer.idleTime

    idleTimer.intervalInstance = window.setInterval(() => {
      idleTimer.currentIdleTime -= INTERVAL_TIMEOUT
      idleTimer.onTick?.(idleTimer.currentIdleTime)

      if (idleTimer.currentIdleTime <= 0) {
        window.clearInterval(idleTimer.intervalInstance)
        idleTimer.onEnd()
      }
    }, INTERVAL_TIMEOUT)
  }

  function resetIdleTimer() {
    window.clearInterval(idleTimer.intervalInstance)
    idleTimer.onReset()
    createIntervalInstance()
  }

  const startIdleTimer = () => {
    createIntervalInstance()
    idleTimer.resetEvents.forEach((event) => {
      document.addEventListener(event, resetIdleTimer)
    })
  }

  const cancelIdleTimer = () => {
    cancelTimerSubscriptions()
    window.clearInterval(idleTimer.intervalInstance)
  }

  onUnmounted(cancelIdleTimer)

  return {
    startIdleTimer,
    cancelIdleTimer,
    resetIdleTimer
  }
}
